/**
 * Pre-compiled es messages for Calendar
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  nextMonth: `Próximo mes`,
  nextYear: `Próximo año`,
  previousMonth: `Mes anterior`,
  previousYear: `Año anterior`,
};
